
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.3 39a1.461 1.461 0 01-1.461-1.461V2.461a1.461 1.461 0 012.249-1.23l27.4 17.538a1.459 1.459 0 010 2.46L7.087 38.77A1.466 1.466 0 016.3 39z"}})])
          )
        }
      }
    